import { render, staticRenderFns } from "./payment-detail.vue?vue&type=template&id=523f51d6&scoped=true"
import script from "./payment-detail.vue?vue&type=script&lang=js"
export * from "./payment-detail.vue?vue&type=script&lang=js"
import style0 from "./payment-detail.vue?vue&type=style&index=0&id=523f51d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f51d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('523f51d6')) {
      api.createRecord('523f51d6', component.options)
    } else {
      api.reload('523f51d6', component.options)
    }
    module.hot.accept("./payment-detail.vue?vue&type=template&id=523f51d6&scoped=true", function () {
      api.rerender('523f51d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/list/payment-detail.vue"
export default component.exports